import React from 'react';
import GlobalStyle from './ui/GlobalStyle';
import GlobalFonts from './ui/GlobalFonts';
import BenchHelmet from './BenchHelmet';
import ReactDOM from 'react-dom';
import AppContainer from './AppContainer';
import store from './data/store.redux';
import { Provider } from 'react-redux';
import { ErrorBoundary } from '@datadog/rum-react-integration';
import ErrorBoundaryFallbackUI from './ui/ErrorBoundaryFallbackUI';

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary fallback={ErrorBoundaryFallbackUI}>
      <BenchHelmet />
      <GlobalFonts />
      <GlobalStyle />
      <AppContainer />
    </ErrorBoundary>
  </Provider>,
  document.getElementById('app'),
);
